import request from '../../utils/request';
import type { TreeNode, HospitalStatus } from '@/types';

/** Fetch the tree for a given batch. */
export function fetchTree(batchId: string): Promise<TreeNode> {
    return request.get('/api/analysis/tree', { params: { batch: batchId } }).then((res) => res.data);
}

/** Fetch hospital status for a given node within a batch. */
export function fetchHospitals(nodeId: string, batch: string): Promise<HospitalStatus[]> {
    return request.get('/api/analysis/hospitals', { params: { node: nodeId, batch } }).then((res) => res.data);
}


/** Fetch commentary report data for a batch. */
export function fetchReport(batchId: string): Promise<Record<string, number>> {
    return request.get('/api/analysis/report', { params: { batch: batchId } }).then((res) => res.data);
}

/** Download PPT for a given date. */
export function downloadPPT(date: string): Promise<Blob> {
    return request.get('/api/analysis/ppt', { params: { date }, responseType: 'blob' }).then((res) => res.data);
}
